import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import classnames from 'classnames';

class PresentationHeatMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ratioWidth: 1,
      ratioHeight: 1
    };

    this.onImgLoad = this.onImgLoad.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.getHeatMapStyles = this.getHeatMapStyles.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  onImgLoad({target:img}) {
    if (img) {
      this.setState({
        height: img.offsetHeight,
        width: img.offsetWidth,
        naturalHeight: img.naturalHeight,
        naturalWidth: img.naturalWidth,
        ratioWidth: img.offsetWidth / img.naturalWidth,
        ratioHeight: img.offsetHeight / img.naturalHeight
      });
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const img = document.getElementById(this.props.question.id + "-heatMapImg");
    this.onImgLoad({target: img})
  }

  selectItem(answerId) {
    let {details, answers} = this.props;
    const answer = answers.find(a => a.id === answerId);

    if(this.props.isAnswerDisabled(answerId)){
      return;
    }

    const microTime = getCurrentMicroTime(this.props.startTime);

    if (!details.find(detail => detail.answer === answerId)) {
      if(answer.blocking){
        this.props.onDetailsUpdated([{answer: answerId, microTime}]);
      }else{
        this.props.onDetailsUpdated([...details, {answer: answerId, microTime}]);
      }
    } else {
      this.props.onDetailsUpdated(details.filter(detail => detail.answer !== answerId));
    }

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (answerId) { " + javascript.code + " }")().bind(this);
        func(answerId);
      }
    });
  }

  getHeatMapStyles(answer) {
    const {ratioWidth, ratioHeight} = this.state;

    return {
        width: Math.round(ratioWidth * answer.heatMapWidth) + 'px',
        height: Math.round(ratioHeight * answer.heatMapHeight) + 'px',
        left: Math.round(ratioWidth * answer.heatMapX) + 'px',
        top: Math.round(ratioHeight * answer.heatMapY) + 'px',
    }
  }

  render() {
    const {answers, details, answersImage, heatMapBg, question} = this.props;

    return <div id="heat-map-area" className="d-flex">
      <div className="position-relative mx-auto">
        <img onLoad={this.onImgLoad} id={question.id + "-heatMapImg"} src={heatMapBg} />

        {answers.map(answer => {
          const detail = details.find(det => parseInt(det.answer) === answer.id) || false;

          return <div
            key={'a-' + answer.id}
            className={classnames({
              'cafetery-wrap position-absolute': true,
              'active': !!detail,
            })}
            onClick={() => this.selectItem(answer.id)}
            style={this.getHeatMapStyles(answer)}
          />
        })}
      </div>
    </div>;
  }
}

PresentationHeatMap.propTypes = {
  answers: PropTypes.array.isRequired,
  details: PropTypes.array.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(PresentationHeatMap);